import { motion, AnimatePresence } from "framer-motion";

export default function Toast({ message, show, onClose }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-6 inset-x-0 z-50 flex justify-center pointer-events-none mx-6"
        >
          <div className="bg-black text-white px-6 py-4 rounded-2xl shadow-lg w-full max-w-md mx-auto pointer-events-auto">
            <div className="flex items-center justify-between">
              <span className="text-sm">{message}</span>
              <button
                onClick={onClose}
                className="text-white hover:opacity-70 text-lg"
              >
                ✖
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
